import React from 'react';
import { connect } from 'react-redux';

import { toggleSpinner } from 'apps/auth/actions/appAction';
import BaseLayout from 'apps/auth/components/common/Layout/BaseLayout';
import { InfoPage } from 'apps/auth/components/common/Layout/InfoPage/InfoPage';
import { AUTH_SEND_MAIN_LINK } from 'apps/auth/constants/UrlConstants';
import { usePageMessages } from 'apps/auth/hooks/selectors';

const ConfirmEmailCheckInbox = (props) => {
    const { emailCheckInboxTitle, emailCheckInboxInfo, emailCheckInboxInfo2, emailCheckInboxGotItButton } = usePageMessages();

    return (
        <BaseLayout showChat={false}>
            <InfoPage
                iconName="mail-80"
                iconColor="primary"
                headerText={emailCheckInboxTitle}
                secondaryText={
                    <p>
                        {emailCheckInboxInfo}
                        <br />
                        <br />
                        {emailCheckInboxInfo2}
                    </p>
                }
                primaryButtonType="link"
                primaryButtonCaption={emailCheckInboxGotItButton}
                primaryButtonOnClick={(e) => {
                    e?.preventDefault();
                    props?.toggleSpinner(true);
                    window.location.replace(AUTH_SEND_MAIN_LINK);
                }}
            />
        </BaseLayout>
    );
};

export default connect(null, { toggleSpinner })(ConfirmEmailCheckInbox);
